import { Diff } from 'diff';

/**
 * This is a simple port of diff/word.js from the JsDiff-library, simply making
 * sure that boundary characters (for instance exclamation-marks) are handled
 * as regular characters.
 */


/**
 * Helper-method that parses the result returned from the JsDiff-library
 * into an array of individual words - taking modified words into
 * consideration, so they don't have two separate added/removed parts.
 */
function getDiff(oldStr, newStr) {
  // Start by calculating the basic diff between the two strings
  let diff = diffWords(oldStr, newStr);

  // We're not interested in whitespace when handling differences
  diff.forEach(word => {
    word.value = word.value.replace(/^\s+/, "").replace(/\s+$/, "");
  });

  // Filter away any words that are completely blank
  diff = diff.filter(word => word.value);

  // Find parts that contain more than one word, and make sure to split them up
  // into multiple parts
  for (let delimiterIndex, i = -1; ++i < diff.length;) {
    const currDiff = diff[i];
    if (!currDiff) {
      continue;
    }
    delimiterIndex = currDiff.value.indexOf(" ");

    // If multiple words are contained, then split the entry up into two
    // parts - making sure the current one only contains a single word
    if (delimiterIndex !== -1) {
      // Get the next word
      const nextWord = currDiff.value.substr(delimiterIndex + 1);

      // Keep only the value of the first word in this entry
      currDiff.value = currDiff.value.substr(0, delimiterIndex);

      // Inject the next word as a separate entry
      diff.splice(i + 1, 0, {
        value: nextWord,
        added: currDiff.added,
        removed: currDiff.removed
      });
    }
  }

  // Find words that have simply been modified, and create a single conjoined
  // entry in the diff
  const tmpDiff = [];
  for (let i = -1, j = diff.length; ++i < j;) {
    // If a part was removed, then check to see if another part was immdiately
    // added (we consider this a replacement)
    if (diff[i]?.removed && diff[i + 1] && diff[i + 1]?.added) {
      tmpDiff.push({
        value: diff[i + 1]?.value ?? "",
        modified: true,
        added: false,
        removed: false
      });
      i++;

      // ... Otherwise add it "as is"
    } else {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      tmpDiff.push(diff[i]);
    }
  }
  diff = tmpDiff;
  return diff;
}
const reWhitespace = /\S/;
const wordDiff = new Diff();
wordDiff.equals = function equals(left, right) {
  return left === right || !reWhitespace.test(left) && !reWhitespace.test(right);
};
wordDiff.tokenize = function tokenize(value) {
  return value.split(/(\s+)/);
};
function diffWords(oldStr, newStr) {
  return wordDiff.diff(oldStr, newStr);
}

export { getDiff };
//# sourceMappingURL=util.get-diff.js.map
